module.exports = __webpack_public_path__ + "img/Rogue-undead-m-70.971fe18e.gif";